/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */
import { getWxOpenId } from '@/api/pay'
// 日期格式化
export function parseTime(time, pattern) {
	if (arguments.length === 0 || !time) {
		return null
	}
	const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
			time = parseInt(time)
		} else if (typeof time === 'string') {
			// time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm),'');
		}
		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return time_str
}

// 表单重置
export function resetForm(refName) {
	if (this.$refs[refName]) {
		this.$refs[refName].resetFields();
	}
}

// 回显数据字典
export function selectDictLabel(datas, value) {
	var actions = [];
	Object.keys(datas).some((key) => {
		if (datas[key].value == ('' + value)) {
			actions.push(datas[key].label);
			return true;
		}
	})
	return actions.join('');
}

// 回显数据字典（字符串数组）
export function selectDictLabels(datas, value, separator) {
	var actions = [];
	var currentSeparator = undefined === separator ? "," : separator;
	var temp = value.split(currentSeparator);
	Object.keys(value.split(currentSeparator)).some((val) => {
		Object.keys(datas).some((key) => {
			if (datas[key].dictValue == ('' + temp[val])) {
				actions.push(datas[key].dictLabel + currentSeparator);
			}
		})
	})
	return actions.join('').substring(0, actions.join('').length - 1);
}

// 字符串格式化(%s )
export function sprintf(str) {
	var args = arguments, flag = true, i = 1;
	str = str.replace(/%s/g, function () {
		var arg = args[i++];
		if (typeof arg === 'undefined') {
			flag = false;
			return '';
		}
		return arg;
	});
	return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
	if (!str || str == "undefined" || str == "null") {
		return "";
	}
	return str;
}

// 数据合并
export function mergeRecursive(source, target) {
    for (var p in target) {
        try {
            if (target[p].constructor == Object) {
                source[p] = mergeRecursive(source[p], target[p]);
            } else {
                source[p] = target[p];
            }
        } catch(e) {
            source[p] = target[p];
        }
    }
    return source;
}

/**
* 参数处理
* @param {*} params  参数
*/
export function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && value !== "" && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result
}

export function formatTime(time) {
  const SECOND = 1000;
  const MINUTE = 60 * SECOND;
  const HOUR = 60 * MINUTE;
  const DAY = 24 * HOUR;

  const format = time => padTwo(Math.floor(time));

  const days = Math.floor(time / DAY);
  const hours = format((time % DAY) / HOUR);
  const minutes = format((time % HOUR) / MINUTE);
  const seconds = format((time % MINUTE) / SECOND);
  const millisecond = format(time % SECOND);

  return {
    days,
    hours,
    minutes,
    seconds,
    millisecond
  };
}

function padTwo(t) {
  return Number(t) >= 10 ? t.toString().slice(0, 2) : "0" + t;
}

export function iswxBrowser () {
	var isWechatBrowser = /micromessenger/i.test(navigator.userAgent);
	return isWechatBrowser
}
export function isMobile() {
	if(/phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(navigator.userAgent)){
		return true
	}else{
		return false
	}
	// let flag = navigator.userAgent.match()
	// return flag;
}
//过滤html标签
export function filterHTML(html) {
  return html
    .replace(/<(?:.|\n)*?>/gm, '')
    .replace(/(&rdquo;)/g, '"')
    .replace(/&ldquo;/g, '"')
    .replace(/&mdash;/g, '-')
    .replace(/&nbsp;/g, '')
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/<[\w\s"':=/]*/, '')
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

export function wxcode(gameId){
	let timeStr = new Date().getTime()
	let redirectUri = 'https://pay.7pa.com/wxcode?gameId='+gameId;
	// let redirectUri = 'http://192.168.28.55:8081/wxcode?gameId='+gameId;
	let rurl = 'https://super-admin.7pa.com/wxcommon?redirectUri='+encodeURI(redirectUri);
	
	getWxOpenId({ gameId }).then((res) => {
		console.log(res)
		var obj = {
		  appid:res.data,
		  redirect_uri:encodeURI(rurl),
		  response_type:'code',
		  scope:'snsapi_base',//snsapi_userinfo
		  state:timeStr+'_'+Math.ceil(Math.random()*1000)
		};
		var objStr = param(obj);
		var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?'+objStr+'#wechat_redirect';
		window.location.href = url
	})
	
}
export function isJsonString (str) {
	try{
		if(typeof JSON.parse(str) == 'object'){
			return true
		}
	} catch(e) {
		console.log(e)
	}
	return false
}
export function iosPostMsg (obj) {
  	let backReturn = window.webkit.messageHandlers.eventComplete.postMessage(JSON.stringify(obj));
  	return backReturn;
  }
export function androidPostMsg (obj) {
  	let backReturn = superapi.callAndroidFunction(JSON.stringify(obj));
  	return backReturn;
  }
export function commonPostMsg (params){
	if(process.env.NODE_ENV === 'development'){
		console.log('1111')
	}else{
		var u = navigator.userAgent;
		var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
		var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
		if(isIos){
			console.log('调用苹果端:'+JSON.stringify(params))
			iosPostMsg(params)
		}else if(isAndroid){
			console.log('调用安卓端:'+JSON.stringify(params))
			androidPostMsg(params)
		}
	}
}
